import '@vaadin/vaadin-overlay';
import { OverlayElement } from '@vaadin/vaadin-overlay';
import { registerStyles, css } from '@vaadin/vaadin-themable-mixin/register-styles.js';

registerStyles(
  'select-overlay',
  css`
    :host {
      left: 0;
      top: calc(var(--spacer) / 2);
      z-index: 9999;
      align-items: stretch;
      width: fit-content;
      width: -moz-fit-content;
      height: -moz-fit-content;
      height: fit-content;
      margin: 0;
      opacity: 0;
      min-width: 160px;
    }

    [part='overlay'] {
      border-radius: calc(var(--spacer) / 2);
      box-shadow: none;
      border: 1px solid var(--blue-layout-400-primary);
      flex-direction: column;
      background: var(--white-layout-301-level-0-elevation);
    }

    [part='content'] {
      padding: 0;
    }

    [part='overlay'] ::slotted(.loading-wrapper) {
      box-sizing: border-box;
      line-height: 0;
      text-align: center;
      padding: var(--spacer) calc(var(--spacer) * 2) var(--spacer) var(--spacer);
    }

    :host(.dark-style) {
      [part='overlay'] {
        border-color: var(--dark-blue-702-main-menu);
        box-shadow: -2px 2px 6px 0px var(--chart-050-hover);
      }

      [part='content'] {
        background-color: var(--dark-blue-702-main-menu);
      }
    }
  `,
  { moduleId: 'select-overlay-styles' }
);

export class SelectOverlayElement extends OverlayElement {
  static get is() {
    return 'select-overlay';
  }
}
